import { format as dateFnsFormat } from "date-fns";
import { useUserSettings } from "./use-user-settings";

export function useDateFormat() {
  const { data: user } = useUserSettings();
  const dateFormatPref = user?.preferences?.date_format ?? "dd/MM/yyyy";

  const formatDate = (date: Date | number | string, customFormat?: string) => {
    if (!date) return "";
    const parsedDate = new Date(date);
    if (Number.isNaN(parsedDate.getTime())) return "Invalid Date";

    return dateFnsFormat(parsedDate, customFormat ?? dateFormatPref);
  };

  const formatDateTime = (date: Date | number | string) => {
    if (!date) return "";
    const parsedDate = new Date(date);
    if (Number.isNaN(parsedDate.getTime())) return "Invalid Date";

    return dateFnsFormat(parsedDate, `${dateFormatPref} HH:mm`);
  };

  return { formatDate, formatDateTime, dateFormatPref };
}
